export enum GiveAwardErrors {
  InsufficientCoinBalance = '[GraphQL] Check constraint violation. new row for relation "coin_trx" violates check constraint "non-negative balance"',
  AwardSelfProhibited = "AWARD_SELF_PROHIBITED",
}
